import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    omitFirstItem: Boolean,
  };

  connect() {
    this.makeSlider();
  }

  resize() {
    this.makeSlider();
  }

  makeSlider() {
    if (window.innerWidth > 960) {
      return;
    }

    const items = this.element.querySelectorAll(".post__item");

    // 既に .rank__carousel 済みならスキップ
    if (this.element.querySelector(".rank__carousel")) return;

    if (items.length === 0) {
      return;
    }

    const carouselWrapper = document.createElement("div");
    carouselWrapper.classList.add("rank__carousel");

    items.forEach((item, index) => {
      if (index <= 0) {
        if (!this.hasOmitFirstItemValue || this.omitFirstItemValue == false) {
          carouselWrapper.appendChild(item);
        }
      } else {
        carouselWrapper.appendChild(item);
      }
    });

    this.element.appendChild(carouselWrapper);
  }
}
